import {
  House, Siren, ChartColumn, Earth, Bug, Grid3x3, Crosshair, Radar, KeyRound, ShieldCheck, FileText, Settings, Crown, Fingerprint,
} from 'lucide-react';

/**
 * The information architecture in one place: the sidebar, breadcrumbs, the
 * command palette and the g-shortcuts all read from here, so a destination is
 * named and placed the same way everywhere.
 *
 * keys: the "g then <key>" shortcut.
 */
export const CUSTOMER_NAV = [
  { group: null, items: [
    { to: '/home', label: 'Home', icon: House, keys: 'h' },
  ] },
  { group: 'Monitor', items: [
    { to: '/threats', label: 'Threats', icon: Siren, keys: 't' },
    { to: '/analytics', label: 'Analytics', icon: ChartColumn, keys: 'a' },
    { to: '/map', label: 'Threat map', icon: Earth, keys: 'm' },
  ] },
  { group: 'Investigate', items: [
    { to: '/vulnerabilities', label: 'Vulnerabilities', icon: Bug, keys: 'v' },
    { to: '/attack', label: 'ATT&CK', icon: Grid3x3, keys: 'k' },
    { to: '/actors', label: 'Threat actors', icon: Fingerprint, keys: 'p' },
    { to: '/hunting', label: 'Threat hunting', icon: Crosshair, keys: 'u' },
  ] },
  { group: 'Exposure', items: [
    { to: '/exposure/dark-web', label: 'Dark web', icon: Radar, keys: 'd' },
    { to: '/exposure/credentials', label: 'Credentials', icon: KeyRound, keys: 'c' },
    { to: '/exposure/brand', label: 'Brand protection', icon: ShieldCheck, keys: 'b' },
  ] },
  { group: 'Workspace', items: [
    { to: '/reports', label: 'Reports', icon: FileText, keys: 'r' },
    { to: '/settings', label: 'Settings', icon: Settings, keys: 's' },
  ] },
];

export const ADMIN_NAV = [
  { group: null, items: [
    { to: '/admin/dashboard', label: 'Admin console', icon: Crown },
    { to: '/admin/actors', label: 'Threat actor profiles', icon: Fingerprint },
  ] },
];

const flat = (nav) => nav.flatMap((g) => g.items.map((i) => ({ ...i, group: g.group })));
export const CUSTOMER_ITEMS = flat(CUSTOMER_NAV);
export const ADMIN_ITEMS = flat(ADMIN_NAV);

/** [group, label] for the breadcrumb of a pathname (longest matching prefix). */
export function routeTrail(pathname, variant = 'customer') {
  const items = variant === 'admin' ? ADMIN_ITEMS : CUSTOMER_ITEMS;
  const hit = items
    .filter((i) => pathname === i.to || pathname.startsWith(`${i.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];
  if (!hit) return [];
  return hit.group ? [hit.group, hit.label] : [hit.label];
}
